/* eslint-disable no-unused-vars */
/* eslint-disable no-control-regex */
import "../../styles/Sidebar.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Link from "../common/Link";
import { useLocation } from "react-router-dom";
import DashboardIconPurple from "../../assets/Icons/dashboard 1.svg";
import DashboardIconWhite from "../../assets/Icons/dashboard-white.svg";
import BoardIconWhite from "../../assets/Icons/friends 1.svg";
import BoardIconPurple from "../../assets/Icons/friends-purple.svg";
import ManagementIconWhite from "../../assets/Icons/team 1.svg";
import ManagementIconPurple from "../../assets/Icons/team-purple.svg";
import AdmissionIconWhite from "../../assets/Icons/AdmissionIcon.svg";
import TeacherPurple from "../../assets/Icons/teacher 1.png";
import TeacherIconWhite from "../../assets/Icons/teacher 1.svg";
import AdmissionIconPurple from "../../assets/Icons/AdmissionIconPurple.svg";
import EducationIconPurple from "../../assets/Icons/education.svg";
import EducationIconWhite from "../../assets/Icons/education-white.svg";
import Logo from "../../assets/Icons/Frame 475.svg";
import ArrowRight from "../../assets/Icons/arrow-right.svg";
import { useDispatch, useSelector } from "react-redux";
import { loginClear } from "../../redux/actions/authActions";
import ModalPopup from "../common/Modal";
import logOutGif from "../../assets/gifs/log-out.gif";
import NewsIconWhite from "../../assets/Icons/NewsManagement.svg";
import NewsIconPurple from "../../assets/Icons/NewsManagementPurple.svg";
import DepartmentIconWhite from "../../assets/Icons/Department.svg";
import DepartmentIconPurple from "../../assets/Icons/DepartmentPurple.svg";
import ExtracurricularIconWhite from "../../assets/Icons/Extracurricular.svg";
import ExtracurricularIconPurple from "../../assets/Icons/ExtracurricularPurple.svg";
import RolesIconWhite from "../../assets/Icons/roles.svg";
import RolesIconPurple from "../../assets/Icons/rolesPurple.svg";
import AdminManagementWhite from "../../assets/Icons/adminManagement.svg";
import AdminManagementPurple from "../../assets/Icons/adminManagementPurple.svg";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import { CheckPermission, CheckPermissionForAdmin, getBoardManagementPath } from "../../helpers/uttils";
import SettingIconWhite from "../../assets/Icons/settings.svg";
import SettingIconPurple from "../../assets/Icons/settingsPurple.svg";
import { useParams } from "react-router-dom";
import { selectAuthGate } from "../../redux/selectors/authSelector";
export const adminSidebarItems = [
  {
    name: "Dashboard",
    permission: "view_Admin_Dashboard",
    icon: {
      default: DashboardIconWhite,
      active: DashboardIconPurple,
    },
    path: "admin-dashboard",
  },
  {
    name: "School Management",
    permission: "view_School",
    icon: {
      default: ManagementIconWhite,
      active: ManagementIconPurple,
    },
    path: "admin-school",
  },
  // {
  //   name: "Content Management",
  //   permission: 'view_Content',
  //   icon: {
  //     default: EducationIconWhite,
  //     active: EducationIconPurple,
  //   },
  //   path: "/admin-content",
  // },
  {
    name: "Roles & Permissions",
    icon: {
      default: RolesIconWhite,
      active: RolesIconPurple,
    },
    access: "admin",
    path: "admin-role",
  },
  {
    name: "Admin Management",
    icon: {
      default: AdminManagementWhite,
      active: AdminManagementPurple,
    },
    access: "admin",
    path: "admin-subadmin",
  },
  {
    name: "Activity Logs",
    icon: {
      default: AdminManagementWhite,
      active: AdminManagementPurple,
    },
    access: "admin",
    path: "admin-activity",
  },
  {
    name: "Credit History",
    icon: {
      default: AdminManagementWhite,
      active: AdminManagementPurple,
    },
    access: "admin",
    path: "admin-credit-history",
  },
  {
    name: "Settings",
    icon: {
      default: SettingIconWhite,
      active: SettingIconPurple,
    },
    access: "admin",
    path: "admin-settings",
  },
];

const getSidebarItems = (countryCode) => {
  const boardLabel =
    countryCode.toUpperCase() === "UG"
      ? "School Management Committee"
      : "Board Management";
  const basePath = getBoardManagementPath(countryCode);
  return [
    {
      name: "Dashboard",
      permission: "view_Dashboard",
      icon: { default: DashboardIconWhite, active: DashboardIconPurple },
      path: "dashboard",
    },
    {
      name: boardLabel,
      permission: "view_Board_Management",
      icon: {
        default: BoardIconWhite,
        active: BoardIconPurple,
      },
      path: basePath,
    },
    {
      name: "School Management",
      permission: "view_School_Management",
      icon: {
        default: ManagementIconWhite,
        active: ManagementIconPurple,
      },
      path: "school-management",
    },
    {
      name: "Teacher Management",
      permission: "view_Teacher_Management",
      icon: {
        default: TeacherIconWhite,
        active: TeacherPurple,
      },
      path: "teacher-management",
    },
    {
      name: "Admissions",
      permission: "view_Admissions",
      icon: {
        default: AdmissionIconWhite,
        active: AdmissionIconPurple,
      },
      path: "admissions",
    },
    {
      name: "News Management",
      permission: "view_News_Management",
      icon: {
        default: NewsIconWhite,
        active: NewsIconPurple,
      },
      path: "news-management",
    },
    {
      name: "Education",
      permission: "view_Education",
      icon: {
        default: EducationIconWhite,
        active: EducationIconPurple,
      },
      path: "education",
    },
    {
      name: "Department",
      permission: "view_Department",
      icon: {
        default: DepartmentIconWhite,
        active: DepartmentIconPurple,
      },
      path: "department",
    },
    {
      name: "Parent Management",
      permission: "view_parents",
      icon: {
        default: BoardIconWhite,
        active: BoardIconPurple,
      },
      path: "parent-management",
    },
    {
      name: "Communication",
      permission: "view_Communication",
      icon: {
        default: NewsIconWhite,
        active: NewsIconPurple,
      },
      path: "communication",
    },
    {
      name: "Extracurricular",
      permission: "view_Extracurricular",
      icon: {
        default: ExtracurricularIconWhite,
        active: ExtracurricularIconPurple,
      },
      path: "extracurricular",
    },
    {
      name: "Roles & Permissions",
      icon: {
        default: RolesIconWhite,
        active: RolesIconPurple,
      },
      access: "schooladmin",
      path: "role",
    },
    {
      name: "Admin Management",
      icon: {
        default: AdminManagementWhite,
        active: AdminManagementPurple,
      },
      access: "schooladmin",
      path: "subadmin",
    },
    {
      name: "Settings & More",
      icon: {
        default: SettingIconWhite,
        active: SettingIconPurple,
      },
      access: "schooladmin",
      path: "settings",
    },
  ];
};

const Sidebar = () => {
  const navigate = useNavigate();
  const { country } = useParams();
  const location = useLocation();
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);

  const roleType = useSelector((state) => state.auth?.data?.user?.role_type);
  const authGate = useSelector(selectAuthGate);
  const countryCode =
    location.state?.countryCode ||
    localStorage.getItem("activeCountryCode") ||
    authGate?.school?.country_code ||
    authGate?.school?.country ||
    authGate?.user?.country_code || // if exists
    "KE";
  const sidebarItems = getSidebarItems(countryCode);
  const [open, setOpen] = useState("");
  const [modalLogout, setmodalLogout] = useState(false);

  const is_verified = useSelector(
    (state) => state.auth?.data?.user?.school_id?.is_school_verified,
  );
  const school = useSelector((state) => state.auth?.data?.user?.school_id);

  let displaySidebarItems = sidebarItems;
  if (!is_verified) {
    displaySidebarItems = sidebarItems.slice(0, 1);
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  const LogoutCallApi = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.reload();
    return false;
  };

  return (
    <>
      <ModalPopup
        className="alert-box-popup"
        show={modalLogout}
        size="md"
        onHide={() => setmodalLogout(false)}
        heading="Are you sure?"
      >
        <div className="text-center flex justify-center flex-col items-center gap-3 px-3 ">
          <h3>Logout</h3>
          <img src={logOutGif} className="w-[120px] " alt="del" />
          <p className="text-card-body mb-1">
            Are you sure you want to Logout?
          </p>
          <div className="w-full flex justify-between gap-3 mb-2">
            <button
              className="bg-secondary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
              onClick={() => {
                LogoutCallApi();
                setmodalLogout(false);
              }}
            >
              Yes
            </button>
            <button
              className="bg-primary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
              onClick={() => setmodalLogout(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalPopup>

      <div className="bg-primary_main text-white h-[94vh] w-20 md:w-60 transition-all duration-300 rounded-2xl fixed flex flex-col">
        <div
          className="p-3 hidden md:block text-2xl font-bold text-white d-flex justify-content-center flex-col items-center cursor-pointer"
          onClick={() => {
            (role === "schooladmin" || roleType === "schoolsubadmin") &&
              navigate(`/${country}/profile`);
          }}
        >
          {school?.logo ? (
            <img src={school.logo} className="w-20 h-20" alt="School Logo" />
          ) : (
            <img src={Logo} className="h-20" alt="Default Logo" />
          )}
        </div>

        {/* Scrollable Nav */}
        <nav className="flex-1 overflow-y-auto mt-3 mx-[16.5px] space-y-2 max-h-[67vh] h-[67vh] lg:h-[100vh] md:h-[100vh]">
          {displaySidebarItems.map((item) => {
            // ✅ Pass role as third parameter
            if (
              CheckPermission(permissions, item.permission, role) ||
              (item?.access && item?.access === role)
            ) {
              return (
                <NavLink
                  key={item.name}
                  to={item.path}
                  end
                  className={({ isActive }) =>
                    `group flex items-center md:justify-start justify-center px-2 py-[0.75rem] space-x-3 rounded-md transition-all mb-[10px] 
                    ${isActive
                      ? "bg-white text-primary_main font-semibold"
                      : "text-white hover:bg-white"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span
                        className={`text-xl group-hover:text-primary_main pl-1 ${isActive ? "text-primary_main" : ""}`}
                      >
                        <img
                          src={isActive ? item.icon.active : item.icon.default}
                          className="max-w-fit group-hover:hidden"
                          alt=""
                        />
                        <img
                          src={item.icon.active}
                          className={`max-w-fit hidden group-hover:block ${isActive ? "block" : ""}`}
                          alt=""
                        />
                      </span>
                      <span
                        className={`hidden md:inline group-hover:text-primary_main ${isActive ? "text-primary_main" : ""}`}
                      >
                        {item.name}
                      </span>
                    </>
                  )}
                </NavLink>
              );
            }
            return null;
          })}

          {adminSidebarItems.map((item) => {
            // ✅ Pass role as third parameter
            if (
              CheckPermissionForAdmin(permissions, item.permission, role) ||
              (item?.access && item?.access === role)
            ) {
              return (
                <NavLink
                  key={item.name}
                  to={item.path}
                  end
                  className={({ isActive }) =>
                    `group flex items-center md:justify-start justify-center px-2 py-[0.75rem] space-x-3 rounded-md transition-all mb-[10px] 
                    ${isActive
                      ? "bg-white text-primary_main font-semibold"
                      : "text-white hover:bg-white"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span
                        className={`text-xl group-hover:text-primary_main pl-1 ${isActive ? "text-primary_main" : ""}`}
                      >
                        <img
                          src={isActive ? item.icon.active : item.icon.default}
                          className="max-w-fit group-hover:hidden"
                          alt=""
                        />
                        <img
                          src={item.icon.active}
                          className={`max-w-fit hidden group-hover:block ${isActive ? "block" : ""}`}
                          alt=""
                        />
                      </span>
                      <span
                        className={`hidden md:inline group-hover:text-primary_main ${isActive ? "text-primary_main" : ""}`}
                      >
                        {item.name}
                      </span>
                    </>
                  )}
                </NavLink>
              );
            }
            return null;
          })}
        </nav>

        <div className="w-full p-[0.75rem] border-t mt-3 border-white/20 z-10">
          <button
            onClick={() => setmodalLogout(true)}
            className="group w-full flex items-center md:justify-start justify-center px-3 py-[0.75rem] space-x-3 rounded-md transition-all text-white hover:bg-white"
          >
            <span className="text-xl relative">
              <img
                src={BoardIconWhite}
                className="max-w-fit block group-hover:hidden"
                alt="logout icon"
              />
              <img
                src={BoardIconPurple}
                className="max-w-fit hidden group-hover:block"
                alt="logout icon"
              />
            </span>
            <span className="hidden md:inline group-hover:text-primary_main">
              Log Out
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export { Sidebar };

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const { country } = useParams();
//   console.log("country:: ", country)
//   // const permission = useSelector(isPermission);
//   const [open, setOpen] = useState("");
//   const [modalLogout, setmodalLogout] = useState(false);
//   // const [pending_count, setPending_count] = useState(0);
//   const location = useLocation();
//   const permissions = useSelector(isPermission);
//   const role = useSelector(isRole)
//   // const is_approved = useSelector((state) => state.auth?.data?.user?.is_approved); //true for direct created user by admin
//   // const logo = useSelector((state) => state.auth?.data?.user?.school_id?.logo);
//   // const createdBy = useSelector((state) => state.auth?.data?.user?.created_by);
//   const roleType = useSelector((state) => state.auth?.data?.user?.role_type);

//   const is_verified = useSelector((state) => state.auth?.data?.user?.school_id?.is_school_verified);
//   const school = useSelector((state) => state.auth?.data?.user?.school_id);

//   if (!is_verified) {
//     sidebarItems = sidebarItems.slice(0, 1);
//   }

//   //   const CheckPermission = (allPermissions, requestedPermission) => {
//   //     if(allPermissions.length === 0 ) return true;
//   //     if ( allPermissions.includes(requestedPermission)) return true;
//   //     return false;
//   // }

//   // const count = async () => {
//   //   Postdata(HttpService.Request_pending_count).then((response) => {
//   //     if (response.status === 200) {
//   //       setPending_count(response.data.pending_requests);
//   //     }
//   //   });
//   // };

//   useEffect(() => {
//     const currentPage = location.pathname;
//     console.log(currentPage, "curre");
//     var parts = currentPage.split("/");
//     if (parts[1] == "leaderboard" || parts[1] == "report") {
//       var extractedPart = "/" + parts[1] + "/" + parts[2];
//     } else if (parts[1] == "contest" && parts[2] == "add") {
//       var extractedPart = "/" + parts[1] + "/" + parts[2];
//     } else if (parts[1] == "spin-wheel" && parts[2] == "user-records") {
//       var extractedPart = "/" + parts[1] + "/" + parts[2];
//     } else {
//       var extractedPart = "/" + parts[1];
//     }
//     console.log(extractedPart, "extractedPart");
//     const allA = document.getElementsByTagName("A");
//     for (let i = 0, len = allA.length; i < len; i++) {
//       if (allA[i].pathname === extractedPart) {
//         allA[i].classList.add("active");
//       } else {
//         allA[i].classList.remove("active");
//       }
//     }
//     console.log("permissions>>>>>>>>>>", permissions)
//     // navigate("/dashboard");

//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth",
//     });
//   }, [location.pathname]);

//   const LogoutCallApi = () => {
//     // dispatch(loginClear());
//     window.localStorage.removeItem('authorizationToken');
//     window.sessionStorage.clear();
//     window.location.reload();
//     return false;
//   };

//   return (
//     <>
//       <ModalPopup
//         className="alert-box-popup"
//         show={modalLogout}
//         size="md"
//         onHide={() => setmodalLogout(false)}
//         heading="Are you sure?"
//       >
//         <div className="text-center flex justify-center flex-col items-center gap-3 px-3 ">
//           <h3>Logout</h3>
//           <img src={logOutGif} className="w-[120px] " alt="del" />
//           <p className="text-card-body mb-1">
//             Are you sure you want to Logout?
//           </p>
//           <div className="w-full flex justify-between gap-3 mb-2">
//             <button
//               className="bg-secondary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
//               onClick={() => {
//                 LogoutCallApi();
//                 setmodalLogout(false);
//               }}
//             >
//               Yes
//             </button>
//             <button
//               className="bg-primary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
//               onClick={() => setmodalLogout(false)}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </ModalPopup>

//       <div className="bg-primary_main text-white h-[94vh] w-20 md:w-60 transition-all duration-300 rounded-2xl fixed flex flex-col">
//         <div className="p-3 hidden md:block text-2xl font-bold text-white d-flex justify-content-center flex-col items-center" onClick={() => { (role == "schooladmin" || roleType == "schoolsubadmin") && navigate("profile") }}>
//           {
//             school?.logo ? <img src={school?.logo || Logo} className="w-20 h-20" /> : <img src={Logo} className="h-20" />
//           }
//           <div className="flex items-center gap-2"></div>
//         </div>

//         {/* Scrollable Nav */}
//         <nav className="flex-1 overflow-y-auto mt-3  mx-[16.5px] space-y-2 max-h-[67vh] h-[67vh] lg:h-[100vh] md:h-[100vh]">
//           {sidebarItems.map((item) => {
//             if (CheckPermission(permissions, item.permission) || (item?.access && item?.access === role)) {
//               return (
//                 <NavLink
//                   key={item.name}
//                 //  to={`/${country}/${item.path}`}
//                   to={item.path}
//                   end
//                   className={({ isActive }) =>
//                     `group flex items-center md:justify-start justify-center px-2 py-[0.75rem] space-x-3 rounded-md transition-all mb-[10px]
//               ${isActive
//                       ? "bg-white text-primary_main font-semibold"
//                       : "text-white hover:bg-white"
//                     }
//             `
//                   }
//                 >
//                   {({ isActive }) => (
//                     <>
//                       <span className={`text-xl group-hover:text-primary_main pl-1 ${isActive ? "text-primary_main" : ""}`}>
//                         <img
//                           src={isActive ? item.icon.active : item.icon.default}
//                           className="max-w-fit group-hover:hidden"
//                           alt=""
//                         />
//                         <img
//                           src={item.icon.active}
//                           className={`max-w-fit hidden group-hover:block ${isActive ? "block" : ""}`}
//                           alt=""
//                         />
//                       </span>
//                       <span className={`hidden md:inline group-hover:text-primary_main ${isActive ? "text-primary_main" : ""}`}>
//                         {item.name}
//                       </span>
//                     </>
//                   )}
//                 </NavLink>
//               );
//             }
//           })}
//           {adminSidebarItems.map((item) => {
//             if ((CheckPermissionForAdmin(permissions, item.permission)) || (item?.access && item?.access === role)) {
//               return (
//                 <NavLink
//                   key={item.name}
//                   to={item.path}
//                   end
//                   className={({ isActive }) =>
//                     `group flex items-center md:justify-start justify-center px-2 py-[0.75rem] space-x-3 rounded-md transition-all mb-[10px]
//               ${isActive
//                       ? "bg-white text-primary_main font-semibold"
//                       : "text-white hover:bg-white"
//                     }
//             `
//                   }
//                 >
//                   {({ isActive }) => (
//                     <>
//                       <span className={`text-xl group-hover:text-primary_main pl-1 ${isActive ? "text-primary_main" : ""}`}>
//                         <img
//                           src={isActive ? item.icon.active : item.icon.default}
//                           className="max-w-fit group-hover:hidden"
//                           alt=""
//                         />
//                         <img
//                           src={item.icon.active}
//                           className={`max-w-fit hidden group-hover:block ${isActive ? "block" : ""}`}
//                           alt=""
//                         />
//                       </span>
//                       <span className={`hidden md:inline group-hover:text-primary_main ${isActive ? "text-primary_main" : ""}`}>
//                         {item.name}
//                       </span>
//                     </>
//                   )}
//                 </NavLink>
//               );
//             }
//           })}
//         </nav>

//         <div className="w-full p-[0.75rem] border-t mt-3 border-white/20 z-10">
//           <button
//             onClick={() => setmodalLogout(true)}
//             className="group w-full flex items-center md:justify-start justify-center px-3 py-[0.75rem] space-x-3 rounded-md transition-all text-white hover:bg-white"
//           >
//             <span className="text-xl relative">
//               <img
//                 src={BoardIconWhite}
//                 className="max-w-fit block group-hover:hidden"
//                 alt="logout icon"
//               />
//               <img
//                 src={BoardIconPurple}
//                 className="max-w-fit hidden group-hover:block"
//                 alt="logout icon"
//               />
//             </span>
//             <span className="hidden md:inline group-hover:text-primary_main">
//               Log Out
//             </span>
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export { Sidebar };

//  <div className="sidebar">
//       <ul>
//         <li>
//           <Link to="/dashboard">
//             <i className="mdi mdi-view-dashboard"></i> <span>Dashboard</span>
//           </Link>
//         </li>
//         <li>
//           <Link to="/school">
//             <i className="mdi mdi-school"></i> <span>School</span>
//           </Link>
//         </li>
//         <li
//           onClick={() => setOpencall("content")}
//           className={open == "content" ? `active` : ``}
//         >
//           <a className="has-arrow">
//             <i className="fab fa-modx "></i>
//             <span>content</span>
//           </a>
//           <ul className="sub-menu" aria-expanded="false">

//             <li>
//               <Link onClick={(e) => e.stopPropagation()} to="/contest">
//                 Contests
//               </Link>
//             </li>

//             <li>
//               <Link onClick={(e) => e.stopPropagation()} to="/contest/add">
//                 Add Contest
//               </Link>
//             </li>

//             {/*  <li>
//                     <Link
//                     onClick={(e) => e.stopPropagation()}
//                     to="/opinionQuestions"
//                      >
//                       <span>Opinion Questions</span>
//                     </Link>
//                 </li>  */}
//             <li>
//               <Link
//                 onClick={(e) => e.stopPropagation()}
//                 to="/contest_category"
//               >
//                 Contest Categories
//               </Link>
//             </li>
//             <li>
//               <Link
//                 onClick={(e) => e.stopPropagation()}
//                 to="/contest_gift"
//               >
//                 Contest Gift
//               </Link>
//             </li>

//           </ul>
//         </li>
//          <li>
//           <Link to="/board-management">
//             <i className="mdi mdi-account-tie"></i> <span>Board Management</span>
//           </Link>
//         </li>
//       </ul>
//     </div>
